const message = {
  msg_1: '新闻',
  msg_2: '上一页',
  msg_3: '下一页',
}

export default message